var map = {
	"./colis/colis_1.jpg": 2579,
	"./foret/foret_1.jpg": 9277,
	"./genie/genie_1.jpg": 5167,
	"./porte/porte_1.jpg": 5120,
	"./vaisseau/vaisseau_1.jpg": 9155
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1202;